import { Component } from '@angular/core';
import {IonicPage, NavController, NavParams} from 'ionic-angular';

@IonicPage()
@Component({
  selector: 'page-badge-achieved',
  templateUrl: 'badge-achieved.html',
})
export class BadgeAchievedPage {

  badgeName: string
  badgeImage: string
  badgeLevel: number

  constructor(private navParams: NavParams, private navCtrl: NavController) {}

  ionViewWillLoad() {
    this.badgeName = this.navParams.get('badgeName');
    this.badgeImage = this.navParams.get('badgeImage');
    this.badgeLevel = this.navParams.get('badgeLevel');
  }

  goBack() {
    this.navCtrl.pop();
  }

  getBadgeLevelOutline() {
    switch (this.badgeLevel) {
      case 1:
        return 'bronze';
      case 2:
        return 'silver';
      case 3:
        return 'gold';
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/core/pages/badge-achieved/badge-achieved.ts